module.exports = "<template> <sio-file-input config.bind=field value.bind=field.value></sio-file-input> </template>";